export const WIDTH = 300;
export const HEIGHT = 200;
export const PADDING = 10;
